import { Permission } from "@/components/UserManagement/types";

// Rubicon org IDs that can access all organizations
export const RUBICON_ADMIN_ORG_IDS = [
  "947cabf8-2f8c-4628-a0df-1440be75908e", // Rubicon prod
  "05f95617-2631-47db-8dc8-a272a7076756", // Rubicon test
];

export interface IFieldEvent {
  eventName: string;
  fieldToUpdate: string;
  newValue: string;
}

export interface IFieldConfiguration {
  formatRegex?: string;
  events?: IFieldEvent[];
}

export interface IPoliceServiceConfiguration {
  id: string;
  testID: string;
  fieldConfigurations?: { [key: string]: IFieldConfiguration };
  units?: { label: string; value: string }[];
  shortName?: string;
  fullName?: string;
  region: string;
  mapCenter?: { lat: number; lng: number };
  apps: Permission[];
  logoURL?: string;
  avatarURL?: string;
  generateAttachmentDescriptions?: boolean;
  servicesURLSlug?: string;
  disableModificationRequest?: boolean;
  apiRegion?: string;
  regionFilterOptions?: { label: string; value: string }[];
  citizenEngageDisableHiddenContactNumber?: string;
  citizenEngageDisableReportsContactNumber?: string;
}

export interface ISSOConfiguration {
  fullName: string;
  logoURL?: string;
  ssoSlug?: string;
  ssoProvider?: string;
}

export const ssoConfigurations: ISSOConfiguration[] = [
  {
    fullName: "Abbotsford Police Department",
    logoURL: "/service-logos/abbotsford_police_department_crest.png",
    ssoSlug: "abbotsford-pd",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Albuquerque Police Department",
    logoURL: "/service-logos/albuquerque_police_department_crest.png",
    ssoSlug: "albuquerque-pd",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Anishinabek Police Service",
    logoURL: "/service-logos/anishinabek_police_service_logo.png",
    ssoSlug: "anishinabek-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Barrie Police Service",
    logoURL: "/service-logos/Barrie-Police-Service-Logo.png",
    ssoSlug: "barrie-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Brantford Police Service",
  },
  {
    fullName: "Brockville Police Service",
    logoURL: "/service-logos/brockville_police_service_logo.png",
    ssoSlug: "brockville-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Chatham-Kent Police Service",
    logoURL: "/service-logos/chatham-kent_police_service_logo.png",
    ssoSlug: "ckps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Cobourg Police Service",
  },
  {
    fullName: "Cornwall Police Service",
    logoURL: "/service-logos/cornwall_police_service_logo.png",
    ssoSlug: "cornwall-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Criminal Intelligence Service Ontario",
    logoURL: "/service-logos/CISO-Logo.png",
    ssoSlug: "ciso",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Douglas County Sheriff's Office",
    logoURL: "/service-logos/douglas_county_sherrifs_office_crest.png",
    ssoSlug: "dcso",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Greater Sudbury Police Service",
    logoURL: "/service-logos/greater_sudbury_police_service_logo.png",
    ssoSlug: "gsps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Hamilton Police Service",
    logoURL: "/service-logos/hamilton_police_service_logo.png",
    ssoSlug: "hamilton-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Kawartha Lakes Police Service",
    logoURL: "/service-logos/KLPS-Logo.png",
    ssoSlug: "kawartha-lakes-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "London Police Service",
    logoURL: "/service-logos/london_police_service_logo.png",
    ssoSlug: "london-police-service",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "New Westminster Police Department",
    logoURL: "/service-logos/new_westminster_police_department_crest.png",
    ssoSlug: "new-westminster-pd",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Niagara Regional Police Service",
    logoURL: "/service-logos/niagara_regional_police_service_crest.png",
    ssoSlug: "niagara-regional-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Ontario Provincial Police",
    logoURL: "/service-logos/OPP.png",
    ssoSlug: "opp",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Ottawa Police Service",
    logoURL: "/service-logos/ottawa_police_service_crest.png",
    ssoSlug: "ottawa-police-service",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Peel Regional Police",
    logoURL: "/service-logos/Peel_Regional_Police_Logo.png",
    ssoSlug: "peel-rp",
    ssoProvider: "Okta",
  },
  {
    fullName: "Peterborough Police Service",
    logoURL: "/service-logos/peterborough_police_service_logo.png",
    ssoSlug: "peterborough-police-service",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Rama Police Service",
    logoURL: "/service-logos/rama_police_service_crest.png",
    ssoSlug: "rama-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Sarnia Police Service",
    logoURL: "/service-logos/sarnia_police_service_logo.png",
    ssoSlug: "sarnia-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Sault Ste. Marie Police Service",
    logoURL: "/service-logos/sault_ste_marie_police_service_logo.png",
    ssoSlug: "ssmps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Thunder Bay Police Service",
    logoURL: "/service-logos/thunder_bay_police_service_logo.png",
    ssoSlug: "thunder-bay-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Timmins Police Service",
    logoURL: "/service-logos/timmins_police_service_logo.png",
    ssoSlug: "timmins-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Waterloo Regional Police Service",
    logoURL: "/service-logos/waterloo_regional_police_service_logo.png",
    ssoSlug: "waterloo-regional-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Wikwemikong Tribal Police Service",
    logoURL: "/service-logos/Wikwemikong_Tribal_Police.png",
    ssoSlug: "wtps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Woodstock Police Service",
    logoURL: "/service-logos/woodstock_police_service_logo.png",
    ssoSlug: "woodstock-ps",
    ssoProvider: "Microsoft",
  },
  {
    fullName: "Victoria Police Department",
    logoURL: "/service-logos/victoria_police_department_crest.png",
    ssoSlug: "victoria-pd",
    ssoProvider: "Microsoft",
  },
  // {
  //   fullName: "DM Org",
  //   ssoSlug: "dm",
  // }
];

export const serviceConfigurations: {
  [key: string]: IPoliceServiceConfiguration;
} = {
  // "DM Org": {
  //   id: "05f95617-2631-47db-8dc8-a272a7076abc",
  //   testID: "05f95617-2631-47db-8dc8-a272a7076abc",
  //   shortName: "DM",
  //   fullName: "DM Org",
  //   region: "Cobourg",
  //   mapCenter: { lat: 43.9593, lng: -78.1657 },
  //   apps: [Permission.REPORT_V2],
  // },
  LCBO: {
    id: "a1c50000-1111-4111-8111-111111111111",
    testID: "a1c50000-1111-4111-8111-111111111111",
    shortName: "LCBO",
    fullName: "LCBO",
    region: "LCBO",
    apps: [Permission.REPORT_V2],
  },
  "Cobourg Police Service": {
    id: "2c9159e9-080c-4c54-81d1-700d5c7ef368",
    testID: "c2612d47-2d95-4362-bff0-2d5e695daed7",
    shortName: "CPS",
    fullName: "Cobourg Police Service",
    region: "Cobourg",
    mapCenter: { lat: 43.9593, lng: -78.1657 },
    apps: [Permission.REPORT, Permission.CAMERA_REGISTRY, Permission.ALERT],
    servicesURLSlug: "cobourg-police-service",
  },
  "Timmins Police Service": {
    id: "2c9159e9-080c-4c54-81d1-700d5c7ef399",
    testID: "2c9159e9-080c-4c54-81d1-700d5c7ef399",
    shortName: "TPS",
    fullName: "Timmins Police Service",
    region: "Timmins",
    logoURL: "/service-logos/Timmins-Police-Service-Logo.png",
    mapCenter: { lat: 48.476673, lng: -81.330016 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "timmins-police-service",
  },
  "Barrie Police Service": {
    id: "e51f2900-e625-4fe5-907d-7be349974045",
    testID: "b0d585d5-abf0-42a5-8817-2e8e26630ef3",
    shortName: "BPS",
    fullName: "Barrie Police Service",
    region: "Barrie",
    logoURL: "/service-logos/Barrie-Police-Service-Logo.png",
    mapCenter: { lat: 44.386812, lng: -79.692489 },
    apps: [Permission.REPORT_V2, Permission.REGISTRY],
    servicesURLSlug: "barrie-police-service",
  },
  "Kawartha Lakes Police Service": {
    id: "64d88277-48b6-4855-b631-f688c568341d",
    testID: "64d88277-48b6-4855-b631-f688c568341d",
    shortName: "KLPS",
    fullName: "Kawartha Lakes Police Service",
    region: "Kawartha Lakes",
    logoURL: "/service-logos/KLPS-Logo.png",
    mapCenter: { lat: 44.356204, lng: -78.740789 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "kawartha-lakes-police-service",
  },
  "Chatham-Kent Police Service": {
    id: "2b12201d-ac51-490f-913e-a5e1c7a44b82",
    testID: "2b12201d-ac51-490f-913e-a5e1c7a44b82",
    shortName: "CKPS",
    fullName: "Chatham-Kent Police Service",
    region: "Chatham-Kent",
    logoURL: "/service-logos/chatham-kent_police_service_logo.png",
    mapCenter: { lat: 42.405545, lng: -82.189201 },
    apps: [Permission.REPORT_V2, Permission.REGISTRY],
    servicesURLSlug: "chatham-kent-police-service",
  },
  "Cornwall Police Service": {
    id: "f0f7ac44-a51f-479a-82f4-875bf8a75c58",
    testID: "f0f7ac44-a51f-479a-82f4-875bf8a75c58",
    shortName: "CPS",
    fullName: "Cornwall Police Service",
    region: "Cornwall",
    logoURL: "/service-logos/cornwall_police_service_logo.png",
    mapCenter: { lat: 45.027884, lng: -74.735004 },
    apps: [Permission.REPORT_V2, Permission.REGISTRY],
    servicesURLSlug: "cornwall-police-service",
  },
  "Thunder Bay Police Service": {
    id: "125e3901-c045-48e2-b7b2-1786d9473faa",
    testID: "125e3901-c045-48e2-b7b2-1786d9473faa",
    shortName: "TBPS",
    fullName: "Thunder Bay Police Service",
    region: "Thunder Bay",
    logoURL: "/service-logos/thunder_bay_police_service_logo.png",
    mapCenter: { lat: 48.37985, lng: -89.24616 },
    apps: [Permission.REPORT_V2, Permission.ALERT, Permission.MESSAGE],
    servicesURLSlug: "thunder-bay-police-service",
  },
  "Sarnia Police Service": {
    id: "327aa820-c20c-4273-b14a-26b00a9f8cda",
    testID: "327aa820-c20c-4273-b14a-26b00a9f8cda",
    shortName: "SPS",
    fullName: "Sarnia Police Service",
    region: "Sarnia",
    logoURL: "/service-logos/sarnia_police_service_logo.png",
    mapCenter: { lat: 42.97261, lng: -82.406394 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "sarnia-police-service",
  },
  "Peterborough Police Service": {
    id: "c86a7e15-5efc-4bd6-a32d-9cabfd554dbe",
    testID: "c86a7e15-5efc-4bd6-a32d-9cabfd554dbe",
    shortName: "PPS",
    fullName: "Peterborough Police Service",
    region: "Peterborough",
    logoURL: "/service-logos/peterborough_police_service_logo.png",
    mapCenter: { lat: 44.303589, lng: -78.322412 },
    apps: [Permission.REPORT_V2, Permission.ALERT, Permission.MESSAGE],
    servicesURLSlug: "peterborough-police-service",
  },
  "Woodstock Police Service": {
    id: "0851cd7e-81ca-416d-8f2c-ebd456da9ac8",
    testID: "0851cd7e-81ca-416d-8f2c-ebd456da9ac8",
    shortName: "WPS",
    fullName: "Woodstock Police Service",
    region: "Woodstock",
    logoURL: "/service-logos/woodstock_police_service_logo.png",
    mapCenter: { lat: 43.131612, lng: -80.748256 },
    apps: [Permission.REPORT_V2, Permission.MESSAGE, Permission.REGISTRY],
    servicesURLSlug: "woodstock-police-service",
  },
  "Wikwemikong Tribal Police Service": {
    id: "66e2b2bf-90d6-4bfb-abc2-6b7fe9fee338",
    testID: "66e2b2bf-90d6-4bfb-abc2-6b7fe9fee338",
    shortName: "WTPS",
    fullName: "Wikwemikong Tribal Police Service",
    region: "Wikwemikong",
    logoURL: "/service-logos/Wikwemikong_Tribal_Police.png",
    mapCenter: { lat: 45.795855, lng: -81.730029 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "wikwemikong-tribal-police-service",
  },
  "Anishinabek Police Service": {
    id: "0cc0f8e7-016b-4f0e-9f7a-4453bd7d4e82",
    testID: "0cc0f8e7-016b-4f0e-9f7a-4453bd7d4e82",
    shortName: "APS",
    fullName: "Anishinabek Police Service",
    region: "Anishinabek",
    logoURL: "/service-logos/anishinabek_police_service_logo.png",
    mapCenter: { lat: 46.538532, lng: -84.152278 },
    apps: [Permission.REPORT_V2, Permission.ALERT],
    servicesURLSlug: "anishinabek-police-service",
  },
  "Gotham Police Department": {
    id: "dd7931ca-b0a1-4acf-972c-9982ad1f04a5",
    testID: "dd7931ca-b0a1-4acf-972c-9982ad1f04a5",
    shortName: "GPD",
    fullName: "Gotham Police Department",
    region: "Gotham",
    logoURL: "/service-logos/gotham_pd.png",
    avatarURL: "/service-logos/avatar/gotham_pd_avatar.png",
    mapCenter: { lat: 42.346873, lng: -71.046304 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "gotham-police-department",
  },
  "New Gotham Police Service": {
    id: "1fb94191-3003-4a10-914b-dcaf13bad98c",
    testID: "1fb94191-3003-4a10-914b-dcaf13bad98c",
    shortName: "NGPS",
    fullName: "New Gotham Police Service",
    region: "Gotham",
    logoURL: "/service-logos/gotham_pd.png",
    avatarURL: "/service-logos/avatar/gotham_pd_avatar.png",
    mapCenter: { lat: 43.647228, lng: -79.401326 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "new-gotham-police-service",
  },
  "Greater Sudbury Police Service": {
    id: "54a6982e-4800-468a-87fc-fd3074161fc0",
    testID: "54a6982e-4800-468a-87fc-fd3074161fc0",
    shortName: "GSPS",
    fullName: "Greater Sudbury Police Service",
    region: "Sudbury",
    logoURL: "/service-logos/greater_sudbury_police_service_logo.png",
    mapCenter: { lat: 46.49295, lng: -80.99302 },
    apps: [
      Permission.ALERT,
      Permission.REPORT_V2,
      Permission.REGISTRY,
      Permission.MESSAGE,
    ],
    servicesURLSlug: "greater-sudbury-police-service",
  },
  "Criminal Intelligence Service of Ontario": {
    id: "72568a9a-3d58-4c13-9cb2-604118ce7303",
    testID: "4b556c8c-e5fd-4e1d-93fc-81d2e5f5bea4",
    shortName: "CISO",
    fullName: "Criminal Intelligence Service Ontario",
    region: "Ontario",
    logoURL: "/service-logos/CISO-Logo.png",
    mapCenter: { lat: 44.386812, lng: -79.692489 },
    apps: [Permission.ALERT, Permission.REPORT_V2, Permission.INTEL],
    generateAttachmentDescriptions: true,
    servicesURLSlug: "4b556c8c-e5fd-4e1d-93fc-81d2e5f5bea4",
  },
  "Ontario Provincial Police": {
    id: "c9189a82-f262-4d55-b88e-2af39efcdbbe",
    testID: "c9189a82-f262-4d55-b88e-2af39efcdbbe",
    shortName: "OPP",
    fullName: "Ontario Provincial Police",
    region: "Ontario",
    logoURL: "/service-logos/OPP.png",
    mapCenter: { lat: 44.582664, lng: -79.429206 },
    apps: [Permission.ALERT, Permission.REPORT_V2, Permission.MESSAGE],
    units: [
      { label: "North East Region", value: "4POL1" },
      { label: "East Region", value: "3POL1" },
      { label: "Highway Safety Division", value: "5POL1" },
      { label: "West Region", value: "6POL1" },
      { label: "North West Region", value: "2POL1" },
      { label: "Central Region", value: "1POL1" },
    ],
    regionFilterOptions: [
      { label: "Central", value: "1" },
      { label: "North West", value: "2" },
      { label: "East", value: "3" },
      { label: "North", value: "4" },
      { label: "HSD", value: "5" },
      { label: "West", value: "6" },
    ],
    generateAttachmentDescriptions: true,
    servicesURLSlug: "ontario-provincial-police",
  },
  "Peel Regional Police": {
    id: "d718b876-5b95-49d3-93a7-c953233cd73d",
    testID: "1737dc6c-29a7-4a23-9823-fdf50b9730d2",
    fieldConfigurations: {
      "contact.badge_number": {
        formatRegex: "[1-9][0-9]*(c)?$",
        events: [
          {
            eventName: "onChange",
            fieldToUpdate: "email",
            newValue: "#{badge_number}@peelpolice.ca",
          },
        ],
      },
    },
    shortName: "PRP",
    fullName: "Peel Regional Police",
    region: "Peel",
    logoURL: "/service-logos/Peel_Regional_Police_Logo.png",
    apps: [
      Permission.ALERT,
      Permission.REPORT_V2,
      Permission.REGISTRY,
      Permission.MESSAGE,
    ],
    servicesURLSlug: "peel-regional-police",
    mapCenter: { lat: 43.6553, lng: -79.695437 },
  },
  "Hamilton Police Service": {
    id: "ae23c3ba-d64f-41de-b818-9a1b72b894ca",
    testID: "ae23c3ba-d64f-41de-b818-9a1b72b894ca",
    shortName: "HPS",
    fullName: "Hamilton Police Service",
    region: "Hamilton",
    logoURL: "/service-logos/hamilton_police_service_logo.png",
    mapCenter: { lat: 43.242133, lng: -79.875339 },
    apps: [Permission.REPORT_V2, Permission.REGISTRY],
    servicesURLSlug: "hamilton-police-service",
  },
  "Durham Regional Police Service": {
    id: "",
    testID: "",
    shortName: "DRPS",
    fullName: "Durham Regional Police Service",
    region: "Durham",
    apps: [],
  },
  "Toronto Police Service": {
    id: "",
    testID: "",
    shortName: "TPS",
    fullName: "Toronto Police Service",
    region: "Toronto",
    apps: [],
  },
  "Brantford Police Service": {
    id: "acd67f6b-b3f9-4f3e-9460-3e64a45d2f5e",
    testID: "acd67f6b-b3f9-4f3e-9460-3e64a45d2f5e",
    shortName: "BPS",
    fullName: "Brantford Police Service",
    region: "Brantford",
    apps: [Permission.ALERT],
  },
  "Niagara Regional Police Service": {
    id: "b15fbe60-d1a1-4700-a03f-5a6773b0494f",
    testID: "b15fbe60-d1a1-4700-a03f-5a6773b0494f",
    shortName: "NRPS",
    fullName: "Niagara Regional Police Service",
    region: "Niagara",
    apps: [Permission.ALERT, Permission.REPORT_V2],
    logoURL: "/service-logos/niagara_regional_police_service_crest.png",
    mapCenter: { lat: 42.978642, lng: -81.248692 },
    servicesURLSlug: "niagara-regional-police-service",
  },
  "OPP - Ontario Provincial Police": {
    id: "",
    testID: "",
    shortName: "OPP",
    fullName: "Ontario Provincial Police",
    region: "OPP",
    logoURL: "/service-logos/opp_logo.png",
    apps: [],
    units: [
      { label: "North East Region", value: "4POL1" },
      { label: "East Region", value: "3POL1" },
      { label: "Highway Safety Division", value: "5POL1" },
      { label: "West Region", value: "6POL1" },
      { label: "North West Region", value: "2POL1" },
      { label: "Central Region", value: "1POL1" },
    ],
  },
  "Your Police Service": {
    id: "1",
    testID: "",
    shortName: "YPS",
    fullName: "Your Police Service",
    region: "Your Region",
    logoURL: "/service-logos/Timmins-Police-Service-Logo.png",
    fieldConfigurations: {
      "contact.badge_number": {
        formatRegex: "[1-9][0-9]*(c)?$",
        events: [
          {
            eventName: "onChange",
            fieldToUpdate: "email",
            newValue: "#{badge_number}@peelpolice.ca",
          },
        ],
      },
    },
    apps: [
      Permission.REPORT,
      Permission.CAMERA_REGISTRY,
      Permission.ALERT,
      Permission.REPORT_V2,
    ],
  },
  Rubicon: {
    id: "947cabf8-2f8c-4628-a0df-1440be75908e",
    testID: "05f95617-2631-47db-8dc8-a272a7076756",
    shortName: "YPS",
    fullName: "Rubicon",
    region: "Your Region",
    logoURL: "/service-logos/Timmins-Police-Service-Logo.png",
    mapCenter: { lat: 43.9593, lng: -78.1657 },
    fieldConfigurations: {
      "contact.badge_number": {
        formatRegex: "[1-9][0-9]*(c)?$",
        events: [
          {
            eventName: "onChange",
            fieldToUpdate: "email",
            newValue: "#{badge_number}@peelpolice.ca",
          },
        ],
      },
    },
    apps: [
      Permission.REPORT,
      Permission.CAMERA_REGISTRY,
      Permission.ALERT,
      Permission.REPORT_V2,
      Permission.INTEL,
      Permission.REGISTRY,
      Permission.MESSAGE,
      Permission.CONNECT,
    ],
  },
  "Brockville Police Service": {
    id: "180daa34-58a3-4da9-b22c-0889a8628191",
    testID: "180daa34-58a3-4da9-b22c-0889a8628191",
    shortName: "BPS",
    fullName: "Brockville Police Service",
    region: "Brockville",
    logoURL: "/service-logos/brockville_police_service_logo.png",
    mapCenter: { lat: 44.590114, lng: -75.685566 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "brockville-police-service",
  },
  "Sault Ste. Marie Police Service": {
    id: "8e5b58e6-a6c9-4e3a-8618-5a91363594a7",
    testID: "8e5b58e6-a6c9-4e3a-8618-5a91363594a7",
    shortName: "SSMPS",
    fullName: "Sault Ste. Marie Police Service",
    region: "Sault Ste. Marie",
    logoURL: "/service-logos/sault_ste_marie_police_service_logo.png",
    apps: [Permission.REPORT_V2],
    mapCenter: { lat: 46.514706, lng: -84.340724 },
    servicesURLSlug: "sault-ste-marie-police-service",
  },
  "London Police Service": {
    id: "03abd69a-d916-4644-bff1-6fdcba97bdd9",
    testID: "03abd69a-d916-4644-bff1-6fdcba97bdd9",
    shortName: "LPS",
    fullName: "London Police Service",
    region: "London",
    logoURL: "/service-logos/london_police_service_logo.png",
    mapCenter: { lat: 42.978642, lng: -81.248692 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "london-police-service",
    disableModificationRequest: true,
  },
  "Douglas County Sheriff's Office": {
    apiRegion: "us",
    id: "67786785-adf3-4f3c-8b9a-364882587568",
    testID: "67786785-adf3-4f3c-8b9a-364882587568",
    shortName: "DCSO",
    fullName: "Douglas County Sheriff's Office",
    region: "Douglas County",
    logoURL: "/service-logos/douglas_county_sheriffs_office_crest.png",
    mapCenter: { lat: 39.376152, lng: -104.857436 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "douglas-county-sheriffs-office",
    citizenEngageDisableReportsContactNumber: "Communications",
  },
  "Cape Breton Regional Police Service": {
    id: "f3143492-d36b-4cae-978a-0fce5428eb8e",
    testID: "f3143492-d36b-4cae-978a-0fce5428eb8e",
    shortName: "CBRPS",
    fullName: "Cape Breton Regional Police Service",
    region: "Cape Breton",
    logoURL: "/service-logos/cape_breton_regional_police_service_logo.png",
    mapCenter: { lat: 46.136929, lng: -60.187166 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "cape-breton-regional-police-service",
  },
  "Ottawa Police Service": {
    id: "1cfb4ec4-d861-430b-bd40-f85ee09e4a62",
    testID: "1cfb4ec4-d861-430b-bd40-f85ee09e4a62",
    shortName: "OPS",
    fullName: "Ottawa Police Service",
    region: "Ottawa",
    logoURL: "/service-logos/ottawa_police_service_crest.png",
    mapCenter: { lat: 45.400299, lng: -75.7169 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "ottawa-police-service",
    citizenEngageDisableHiddenContactNumber: "613-236-1222 ext. 7300",
  },
  "North Bay Police Service": {
    id: "4b78f34d-0004-474b-ac0a-d91e190bb078",
    testID: "4b78f34d-0004-474b-ac0a-d91e190bb078",
    shortName: "NBPS",
    fullName: "North Bay Police Service",
    region: "North Bay",
    logoURL: "/service-logos/north_bay_police_service_logo.png",
    apps: [Permission.REPORT_V2],
    mapCenter: { lat: 46.514706, lng: -84.340724 },
    servicesURLSlug: "north-bay-police-service",
  },
  "Rama Police Service": {
    id: "2423dce7-70a8-40b1-93dc-5b89f1147c28",
    testID: "2423dce7-70a8-40b1-93dc-5b89f1147c28",
    shortName: "RPS",
    fullName: "Rama Police Service",
    region: "Rama",
    logoURL: "/service-logos/rama_police_service_crest.png",
    apps: [Permission.REPORT_V2],
    mapCenter: { lat: 44.649565, lng: -79.348782 },
    servicesURLSlug: "rama-police-service",
  },
  "Victoria Police Department": {
    id: "3888255b-04e0-4601-bc48-9e6cdc2be2f0",
    testID: "3888255b-04e0-4601-bc48-9e6cdc2be2f0",
    shortName: "VicPD",
    fullName: "Victoria Police Department",
    region: "Victoria",
    logoURL: "/service-logos/victoria_police_department_crest.png",
    apps: [Permission.REPORT_V2, Permission.REGISTRY],
    mapCenter: { lat: 48.428057, lng: -123.36564 },
    servicesURLSlug: "victoria-police-department",
  },
  "Abbotsford Police Department": {
    id: "6131f8bd-9711-4144-bd6a-4b4f8d7dbfea",
    testID: "6131f8bd-9711-4144-bd6a-4b4f8d7dbfea",
    shortName: "APD",
    fullName: "Abbotsford Police Department",
    region: "Abbotsford",
    logoURL: "/service-logos/abbotsford_police_department_crest.png",
    apps: [Permission.REGISTRY],
    mapCenter: { lat: 49.047877, lng: -122.302689 },
    servicesURLSlug: "abbotsford-police-department",
  },
  "New Westminster Police Department": {
    id: "d0b432fb-7eef-402b-b333-946ffa01e130",
    testID: "d0b432fb-7eef-402b-b333-946ffa01e130",
    shortName: "NWPD",
    fullName: "New Westminster Police Department",
    region: "New Westminster",
    logoURL: "/service-logos/new_westminster_police_department_crest.png",
    apps: [Permission.REPORT_V2],
    mapCenter: { lat: 49.20407, lng: -122.913118 },
    servicesURLSlug: "new-westminster-police-department",
  },
  "Livermore Police Department": {
    id: "c717acc4-6628-4675-a083-b7a9fafcbc08",
    testID: "c717acc4-6628-4675-a083-b7a9fafcbc08",
    shortName: "LPD",
    fullName: "Livermore Police Department",
    region: "Alameda County",
    logoURL: "/service-logos/livermore_pd_california_crest.png",
    mapCenter: { lat: 37.680518, lng: -121.772499 },
    apps: [Permission.REPORT_V2],
    servicesURLSlug: "livermore-police-department",
  },
  "Sheridan College": {
    id: "8324eda1-ff51-4ef9-9de0-011400361aa8",
    testID: "8324eda1-ff51-4ef9-9de0-011400361aa8",
    shortName: "SC",
    fullName: "Sheridan College",
    region: "Mississauga",
    logoURL: "/service-logos/sheridan_logo.png",
    apps: [Permission.REPORT_V2],
    mapCenter: { lat: 43.6553, lng: -79.695437 },
    servicesURLSlug: "sheridan-college",
  },
  "Albuquerque Police Department": {
    apiRegion: "us",
    id: "fba28d62-d187-42ee-8165-faf32f70409b",
    testID: "fba28d62-d187-42ee-8165-faf32f70409b",
    shortName: "APD",
    fullName: "Albuquerque Police Department",
    region: "Albuquerque",
    apps: [Permission.REPORT_V2],
    logoURL: "/service-logos/albuquerque_police_department_crest.png",
    mapCenter: { lat: 35.081896, lng: -106.652643 },
    servicesURLSlug: "albuquerque-police-department",
  },
  "Baytown Police Department": {
    id: "770c94f5-89bd-44a2-bb05-798aa2e33920",
    testID: "770c94f5-89bd-44a2-bb05-798aa2e33920",
    shortName: "BPD",
    fullName: "Baytown Police Department",
    region: "Baytown",
    apps: [Permission.REPORT_V2],
    logoURL: "/service-logos/baytown_police_department_crest.png",
    mapCenter: { lat: 29.734641, lng: -94.977344 },
    servicesURLSlug: "baytown-police-department",
  },
  "Waterloo Police Department": {
    id: "39c1bde4-57e4-405d-83f6-b9e483c23596",
    testID: "39c1bde4-57e4-405d-83f6-b9e483c23596",
    shortName: "WPD",
    fullName: "Waterloo Police Department",
    region: "Waterloo",
    apps: [Permission.REPORT_V2],
    logoURL: "/service-logos/waterloo_police_department_crest.png",
    mapCenter: { lat: 42.491453, lng: -92.341684 },
    servicesURLSlug: "waterloo-police-department",
  },
  "Waterloo Regional Police Service": {
    id: "49b72f55-a386-4efb-ab33-95e88bf9e190",
    testID: "49b72f55-a386-4efb-ab33-95e88bf9e190",
    shortName: "WRPS",
    fullName: "Waterloo Regional Police Service",
    region: "Region of Waterloo",
    logoURL: "/service-logos/waterloo_regional_police_service_logo.png",
    apps: [Permission.REPORT_V2],
    mapCenter: { lat: 43.417282, lng: -80.389645 },
    servicesURLSlug: "waterloo-regional-police-service",
  },
};

// Dual-run override populated from /public/communities by useServiceConfigurations.
// While null (API unavailable, or unmounted), getServiceConfig falls back to the
// hardcoded map, so behaviour is unchanged until the backend serves the endpoint.
let apiServiceConfigOverride: {
  [key: string]: IPoliceServiceConfiguration;
} | null = null;

export function setApiServiceConfigOverride(
  map: { [key: string]: IPoliceServiceConfiguration } | null,
): void {
  apiServiceConfigOverride = map;
}

export function getServiceConfig(
  id: string,
  testMode: boolean = false,
  source: {
    [key: string]: IPoliceServiceConfiguration;
  } = apiServiceConfigOverride ?? serviceConfigurations,
) {
  return (
    Object.values(source).filter(
      (service) => (testMode ? service.testID : service.id) === id,
    )[0] ?? {}
  );
}

export const substituteFormatValue = (
  formatString: string,
  data: { [key: string]: string },
): string => {
  let result = formatString;
  for (const key in data) {
    result = result.replace(`#{${key}}`, data[key]);
  }
  return result;
};
